<div class="d-flex flex-column flex-md-row w-100 main">
    <div class="first">
        <div *ngIf="atRegisterForm" [ngClass]="atRegisterForm ? 'numberSelected' : 'number'">1</div>
        <div class="greenCheck" *ngIf="!atRegisterForm">
            <i class="fa fa-check" aria-hidden="true"></i>
        </div>
        <div class="text1">Facility Registration Form</div>
    </div>
    <div class="w-80 mt-3 px-2 line-width line"></div>
    <div class="mt-2 mt-md-0 second">
        <div [ngClass]="!atRegisterForm ? 'numberSelected' : 'number'">2</div>
        <div class="text2">Payment</div>
    </div>
</div>